import { Link } from '@tanstack/react-router';

interface CaseStoryEmptyStateProps {
  readonly caseId: string;
}

export function CaseStoryEmptyState({ caseId }: CaseStoryEmptyStateProps) {
  return (
    <div className="flex h-[calc(100dvh-3rem)] items-center justify-center px-6">
      <div className="max-w-md rounded-xl border border-white/10 bg-surface-raised px-6 py-5 text-center">
        <h1 className="mb-2 text-lg font-semibold">Ingen relevante hendelser ennå</h1>
        <p className="mb-4 text-sm text-text-secondary">
          Marker hendelser som relevante i tidslinjen for å bygge tidslinjevisningen.
        </p>
        <Link
          to="/cases/$caseId"
          params={{ caseId }}
          className="inline-flex rounded-md bg-accent px-3 py-2 text-sm font-medium text-white hover:bg-accent-hover"
        >
          Tilbake til sak
        </Link>
      </div>
    </div>
  );
}
